import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsRewindFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M1.28 11.96L11.44 4.96V10.92L20.3 4.96V18.96L11.44 13V18.96L1.28 11.96Z" />
    </SvgIcon>
  );
});
